import { render, staticRenderFns } from "./ProzessQuillEditor.vue?vue&type=template&id=0307c146"
import script from "./ProzessQuillEditor.vue?vue&type=script&lang=js"
export * from "./ProzessQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./ProzessQuillEditor.vue?vue&type=style&index=0&id=0307c146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports